"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.features = {
    BLAZE: 'global_checkout_blaze',
    CHECKOUT_PRELOAD_ASSETS: 'global_checkout_preload_assets',
    CHECKOUT_RESOURCE: 'global_checkout_resource',
    USE_SELECTED_LANGUAGE: 'global_use_selected_language',
    CHECKOUT_INITIALIZE_ENDPOINT: 'global_checkout_initialize_endpoint',
    SCHEMA_ORG_GENERATION: 'global_schema_org_generation',
    RETURNING_CUSTOMERS: 'global_checkout_returning_customers',
    INJECT_CUSTOM_JS: 'global_inject_client_javascript',
    ENABLE_CARTV2: 'global_shopify_js_cart_v2',
    JAVASCRIPT_MODAL_ENABLED: 'global_javascript_error_modal',
    DISPLAY_PDP_SHIPPING: 'global_display_pdp_shipping',
};
exports.general = {
    FLOW_API_HOST: 'https://api.flow.io',
};
exports.default = {
    features: exports.features,
    general: exports.general,
};
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/country-picker/~/@flowio/browser-bundle/dist/constants.js
// module id = 543
// module chunks = 0 1